// session_reducer.js
import {
  RECEIVE_CURRENT_USER,
  RECEIVE_USER_LOGOUT,
  RECEIVE_USER_SIGN_IN,
  SET_SESSION_EXPIRED,
  CLEAR_SESSION_EXPIRED,
  SESSION_HYDRATE_START,
  SESSION_HYDRATE_DONE,
} from "../actions/session_actions";

const _nullSession = {
  isAuthenticated: false,
  user: null,

  // soft-expire state
  isExpired: false,
  expiredReason: null,

  // signup flow helper
  signedIn: false,

  // ✅ hydration UI flag
  isHydrating: false,
};

const SessionReducer = (state = _nullSession, action) => {
  Object.freeze(state);

  switch (action.type) {
    case SESSION_HYDRATE_START:
      return { ...state, isHydrating: true };

    case SESSION_HYDRATE_DONE:
      return { ...state, isHydrating: false };

    case RECEIVE_CURRENT_USER:
      return {
        ...state,
        isAuthenticated: !!action.currentUser,
        user: action.currentUser,
        signedIn: false,

        // ✅ successful user = not expired
        isExpired: false,
        expiredReason: null,

        // ✅ stop any boot loader
        isHydrating: false,
      };

    case RECEIVE_USER_SIGN_IN:
      return { ...state, signedIn: true };

    case RECEIVE_USER_LOGOUT:
      return { ..._nullSession, isHydrating: false };

    case SET_SESSION_EXPIRED:
      return {
        ...state,
        // leave auth as-is so UI can stay behind modal if you want
        isAuthenticated: state.isAuthenticated,
        isExpired: true,
        expiredReason: action.reason || "expired",
        // ✅ don’t get stuck loading
        isHydrating: false,
      };

    case CLEAR_SESSION_EXPIRED:
      try { window.__COSMETINK_SOFT_EXPIRED__ = false; } catch (e) {}
      return {
        ...state,
        isExpired: false,
        expiredReason: null,
      };

    default:
      return state;
  }
};

export default SessionReducer;
